import React, { Fragment } from 'react';

const AccessibilityText_de = (
  <Fragment>
    <p>
      <strong>Erklärung zur Barrierefreiheit</strong>
    </p>
    <p>
      Das Umweltbundesamt ist bestrebt, den Datacube (
      <a href="https://datacube.uba.de/">https://datacube.uba.de/</a>) im
      Einklang mit den nationalen Rechtsvorschriften zur Umsetzung der
      Richtlinie (EU) 2016/2102 barrierefrei zugänglich zu machen.
      Rechtsgrundlagen hierfür sind das Behindertengleichstellungsgesetz (BGG)
      und die Barrierefreie-Informationstechnik-Verordnung (BITV 2.0).
    </p>
    <p>
      <strong>Stand der Vereinbarkeit mit den Anforderungen</strong>
    </p>
    <p>
      Der Datacube ist derzeit nur teilweise mit den oben genannten
      Anforderungen vereinbar. Einige Inhalte sind noch nicht vollständig
      barrierefrei.
    </p>
    <p>
      <strong>Nicht barrierefreie Inhalte</strong>
    </p>
    <ul>
      <li>
        <p>
          Einige interaktive Elemente und Datenvisualisierungen sind für
          Nutzerinnen und Nutzer mit Sehbehinderungen nicht optimal zugänglich.
        </p>
      </li>
      <li>
        <p>
          Unverhältnismäßige Belastung<strong>:</strong> Aufgrund der
          Komplexität bestimmter Datenstrukturen können nicht alle Informationen
          in einer vollständig barrierefreien Form bereitgestellt werden.
        </p>
      </li>
      <li>
        <p>
          Inhalte in Gebärdensprache sowie in Leichter Sprache sind bisher nicht
          vorhanden.
        </p>
      </li>
      <li>
        <p>
          Hinweise zur Navigation und zur Nutzung des Tools fehlen bislang in
          alternativen Darstellungsformen.
        </p>
      </li>
    </ul>
    <p>
      <strong>Erstellung dieser Erklärung zur Barrierefreiheit</strong>
    </p>
    <p>
      Diese Erklärung wurde am 7. April 2025 erstellt und basiert auf einer
      Selbstbewertung.
    </p>
    <p>
      <strong>Feedback und Barrieren melden</strong>
    </p>
    <p>
      Wenn Sie auf Barrieren stoßen oder Hinweise zur Verbesserung haben, nutzen
      Sie bitte die unten bereitgestellten Kontaktinformationen um dies zu
      melden:
    </p>
    <p>
      Umweltbundesamt
      <br />
      Wörlitzer Platz 1<br />
      06844 Dessau-Roßlau
      <br />
      E-Mail: datacube@uba.de
      <br />
      Telefon: +49-340-2103-0
    </p>
    <p>
      <strong>Schlichtungsverfahren</strong>
    </p>
    <p>
      Falls Sie der Ansicht sind, durch eine nicht ausreichende barrierefreie
      Gestaltung des Datacube benachteiligt zu sein, können Sie sich an die
      Schlichtungsstelle nach § 16 BGG wenden:
    </p>
    <p>
      Schlichtungsstelle BGG
      <br />
      bei dem Beauftragten der Bundesregierung für die Belange von Menschen mit
      Behinderungen
      <br />
      Mauerstraße 53
      <br />
      10117 Berlin
    </p>
    <p>
      👉{' '}
      <a href="https://www.schlichtungsstelle-bgg.de">
        www.schlichtungsstelle-bgg.de
      </a>
    </p>
  </Fragment>
);
export default AccessibilityText_de;
